<div class="status">
  <mat-icon class="fa-spin" *ngIf="status === SmallStatusEnum.loading">autorenew</mat-icon>
  <mat-icon *ngIf="status === SmallStatusEnum.done">published_with_changes</mat-icon>
  <mat-icon *ngIf="status === SmallStatusEnum.error">sync_problem</mat-icon>
</div>
